import { code } from "@spscommerce/utils";

export const SpsListActionBarExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                react: code`
                    function Component (props) {
                        const [itemsSelected, setItemsSelected] = React.useState(3);
                        const handleClear = val => {
                            setItemsSelected(0);
                        };
                        return (
                            <SpsCard>
                                <SpsButton onClick={() => {setItemsSelected(3);}}>Reset</SpsButton>
                                <SpsListActionBar itemsSelected={itemsSelected} clearSelected={handleClear} >
                                    <SpsButton kind="icon" icon="trash" />
                                    <SpsButton kind="icon" icon="printer" />
                                    <SpsButton kind="icon" icon="download-cloud" />
                                    <SpsButton kind="icon" icon="archive" />
                                </SpsListActionBar>
                            </SpsCard>
                        );
                    }
                `
            }
        }
    }
};
